import httpAdmin from '@/httpCommon/axiosClient';

class LocalFileService {
    uploadFile = async (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        const res = await httpAdmin.post('dich_vu/san_pham/upload-file', formData, config);
        return res?.data;
    };
}
export default new LocalFileService();
